__turbopack_context__.v({
  "modalContent": "FolderSharingModal-module__8fIGzW__modalContent",
  "typeahead": "FolderSharingModal-module__8fIGzW__typeahead",
});
